import { useMemo } from 'react'

export interface IDataType {
  fwWingstopConstants?: typeof CONSTANTS
}

export const CONSTANTS = {
  PREP_ITEM_STORE_LOCATION_GROUP_ID: 228,
} as const

const useFwWingstopConstants = () => ({
  fwWingstopConstants: useMemo(
    (): IDataType['fwWingstopConstants'] => CONSTANTS,
    [],
  ),
})

export default useFwWingstopConstants
